import React from "react"
import { useTranslations } from "next-intl"
import { Globe } from "lucide-react"
import { useLocaleStore } from "@/stores/localeStore"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

const languages = [
	{ value: "es", label: "Español" },
	{ value: "ca", label: "Català" },
	{ value: "en", label: "English" },
]

interface LanguageSelectorProps {
	compact?: boolean
	className?: string
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ compact = false, className = "" }) => {
	const t = useTranslations()
	const { locale, setLocale } = useLocaleStore()

	const handleChange = (newLocale: string) => {
		setLocale(newLocale as "es" | "ca" | "en")
		document.cookie = `NEXT_LOCALE=${newLocale}; path=/; max-age=31536000; SameSite=Lax`
		window.location.reload()
	}

	const current = languages.find((l) => l.value === locale)

	if (compact) {
		return (
			<div className={`flex items-center gap-2 ${className}`}>
				<Select value={locale} onValueChange={handleChange}>
					<SelectTrigger className="w-[120px] h-9 bg-white border-gray-200 hover:bg-gray-50">
						<div className="flex items-center gap-2">
							<Globe size={16} className="text-[#2d5c3f]" />
							<SelectValue>{current && <span className="text-sm font-medium">{current.label}</span>}</SelectValue>
						</div>
					</SelectTrigger>
					<SelectContent>
						{languages.map((lang) => (
							<SelectItem key={lang.value} value={lang.value}>{lang.label}</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>
		)
	}

	return (
		<div className={`relative ${className}`}>
			<label className="block text-sm font-medium text-gray-700 mb-2">
				<Globe className="inline w-4 h-4 mr-2" />
				{t("settings.language")}
			</label>
			<Select value={locale} onValueChange={handleChange}>
				<SelectTrigger className="w-full bg-white border-gray-200 hover:bg-gray-50">
					<div className="flex items-center gap-2">
						<Globe size={16} className="text-[#2d5c3f]" />
						<SelectValue>{current && <span className="text-sm font-medium">{current.label}</span>}</SelectValue>
					</div>
				</SelectTrigger>
				<SelectContent>
					{languages.map((lang) => (
						<SelectItem key={lang.value} value={lang.value}>{lang.label}</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	)
}
